import React from 'react'

const PanelMain = () => {
  return (
    <div id='website-responsive' className=''>
    <div className='bg-img' style={{ backgroundImage:'url("panel-testing/Services-Banner-v2.webp")', height:'100%', width:'100%'}}>
        <div className='toxicology-text-padding'>
            <div className='-max-width display-none-1150'>
                <text className='fs-ss-42 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                EXPERIENCE THE<br/>
                BEST LABORATORY<br/>
                TESTING SERVICES
                </text>
            </div>

            <div className='services1-max-width display-block-1150'>
                <text className='fs-ss-32-4 text-montserrat fw-600 lh-1 text-ss-primary ' style={{ letterSpacing:'-1px'}}>
                Experience The
                Best Laboratory
                Testing Services
                </text>
            </div>
        </div>
    </div>
</div>
  )
}

export default PanelMain